<template>
  <Teleport to="body">
    <!-- в Teleport @layer components не срабатывает, пока так -->
    <div class="catalog-filters-mobile__box fixed top-0 left-0 bottom-0 right-0 bg-white">
      <div class="pt-4 min-h-0 grid relative">
        <div class="first-screen relative min-h-0 grid">
          <div class="text-[24px] md:text-[34px] text-center uppercase playfair relative">
            {{ title }}
            <UIIcon
              name="cross"
              class="absolute top-[2px] right-5 scale-[0.6]"
              style="width: 32px; height: 32px;"
              @click="emit('close')"
            />
          </div>

          <div class="first-screen__content grid min-h-0">
            <slot name="first-screen" />
          </div>
        </div>

        <div
          class="second-screen absolute top-0 left-0 bottom-0 right-0 bg-white md:py-5 transition-all duration-200 grid min-h-0"
          :class="secondScreenClass"
        >
          <div class="relative text-[16px] pt-5 md:text-[22px] md:pt-0 text-center">
            {{ secondScreenTitle }}

            <UIIcon
              name="arrow"
              class="absolute top-[26px] left-5 rotate-90 scale-150 md:top-7"
              @click="emit('update:showSecondScreen', false)"
            />
          </div>

          <div class="second-screen__content mt-6 grid min-h-0">
            <slot name="second-screen" />
          </div>
        </div>
      </div>

      <div class="bottom">
        <slot />
      </div>

      <div
        v-if="loading"
        class="catalog-filters-mobile__loader"
      >
        <UiLoader />
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import UIIcon from '~/components/ui/UIIcon.vue';

const props = defineProps<{
  title: string,
  showSecondScreen: boolean,
  secondScreenTitle?: string,
  loading: boolean,
}>();

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'update:showSecondScreen', value: boolean): void
}>();

const secondScreenClass = computed(() => (props.showSecondScreen ? 'translate-x-0' : 'translate-x-full'));
</script>

<style scoped lang="scss">
.second-screen {
  display: grid;
  grid-template-rows: min-content 1fr;
  &__content {
    max-height: 100%;
  }
}

.catalog-filters-mobile__box {
    display: grid;
    grid-template-rows: 1fr min-content;
    z-index: 1001;
}

.catalog-filters-mobile__loader {
  position: absolute;
  top:0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 150px 0;
}
</style>
